// extracted by mini-css-extract-plugin
export default {"view_assignment_table_container":"ViewAssignments_view_assignment_table_container__I0xRo"};